import styled from 'styled-components';

const Text = styled.span`
  ${(props) => props.theme.config.typograph.default};
  color: ${(props) => props.theme.config.colors.secondary};
  font-weight: 700;
`;

export { Text };
